import styled from "styled-components"

const Title = styled.h2`
  &::after {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const GalerieTitle = styled.h3`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const GalerieItemContainer = styled.div`
  @media (max-width: 900px) {
    border-bottom: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

const ListGalerieHeader = styled.div``

export { Title, GalerieTitle, GalerieItemContainer, ListGalerieHeader }
